import { Skeleton } from "antd";
import React, {  } from "react";
import Container from "../../General/Container/Container";

const PersonasAbout = ({
    data,
    loading,
    classColor
}) => {
    return <Container className="minified-result-item dcol download-personas">
        {loading
            ? <Skeleton paragraph={{ rows: 2 }} active />
            : <>
                <span className={`personas-title${classColor}`}>About</span>
                <p>{data}</p>
            </>
        }
    </Container>
}

export default PersonasAbout